var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"likes"},[_c('b-list-group',_vm._l((_vm.likes),function(like){return _c('b-list-group-item',{key:like.id},[_c('Like',{attrs:{"like-title":like.title.rendered,"liked-postid":like.idea_post_id[0]}})],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19952991","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Likes.vue
// module id = null
// module chunks = 